<template>
  <div class="info-box">
    <el-form
      :model="state.model"
      label-width="auto"
      label-position="top"
      ref="formDom"
      size="large"
      class="px-2.5"
    >
      <ul class="flex gap-x-5">
        <el-form-item label="供应商采购">
          <el-switch
            v-model="state.model.is_supplier_purchase"
            :active-value="1"
            :inactive-value="0"
          />
        </el-form-item>
        <el-form-item
          label="供应商"
          prop="name"
          :rules="[
            { required: true, message: '请选择供应商', trigger: 'blur' },
          ]"
          v-if="state.model.is_supplier_purchase"
        >
          <el-select
            v-model="state.model.supplier_id"
            :disabled="state.supplier_id_disabled"
            class="!w-96"
          >
            <template #label="{ label, value }">
              <div class="flex gap-x-5 !w-full">
                <text>{{ label.name }}</text>
                <div
                  class="flex flex-col items-end flex-1 text-gray-400"
                  style="font-size: 12px"
                >
                  {{ label.number }}
                </div>
              </div>
            </template>
            <el-option
              v-for="item in state.gys_data"
              :key="item"
              :label="item"
              :value="item.id"
            >
              <div class="flex gap-x-5 !w-full">
                <text>{{ item.name }}</text>
                <div
                  class="flex flex-col items-end flex-1 text-gray-400"
                  style="font-size: 12px"
                >
                  <text>{{ item.number }}</text>
                </div>
              </div>
            </el-option>
            <template #footer>
              <el-button
                plain
                class="float-right mb-3"
                size="small"
                @click="onLoadGys()"
              >
                刷新
              </el-button>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="采购说明" class="flex-shrink-0 !w-96">
          <el-input v-model="state.model.intro"></el-input>
        </el-form-item>
      </ul>
    </el-form>
    <ul class="flex items-center">
      <li class="flex-1 flex items-center">
        <el-button type="primary" icon="plus" link @click="onAdd">
          新增
        </el-button>
        <el-button
          type="warning"
          icon="plus"
          link
          @click="state.showGysk = true"
          :disabled="!state.model.d_cost_type_pid || !state.model.supplier_id"
        >
          选择常用项
        </el-button>
        <el-button
          type="success"
          icon="plus"
          link
          @click="state.showCbk = true"
          :disabled="!state.model.d_cost_type_pid"
        >
          成本库选择
        </el-button>
        <el-button type="danger" icon="Delete" link @click="onClear">
          清空
        </el-button>
      </li>
      <c_cell title="合计金额">
        <template #default>
          <c_money :key="state.total" :value="state.total" />
        </template>
      </c_cell>
    </ul>
    <el-table
      :data="state.list_data"
      v-loading="!Array.isArray(state.list_data)"
      element-loading-background="rgba(0, 0, 0, 0.2)"
      class="flex-1 mt-3"
      ref="tabDom"
    >
      <el-table-column type="index" :width="55" label="序号" align="center" />
      <el-table-column label="类型" :width="140">
        <template #default="{ row }">
          <el-select v-model="row.d_cost_type_id" placeholder="">
            <el-option
              v-for="item in state.wllx_data"
              :key="item"
              :label="item.name"
              :value="item.id"
            />
            <template #footer>
              <el-button
                plain
                class="float-right mb-3"
                size="small"
                @click="onLoadWllx()"
              >
                刷新
              </el-button>
            </template>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="所属分会">
        <template #default="{ row }">
          <el-select v-model="row.meeting_place_id" placeholder="">
            <el-option
              v-for="item in state.fh_data"
              :key="item"
              :label="item.name"
              :value="item.id"
            />
            <template #footer>
              <el-button
                plain
                class="float-right mb-3"
                size="small"
                @click="onLoadFh()"
              >
                刷新
              </el-button>
            </template>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="名称">
        <template #default="{ row }">
          <el-input v-model="row.name"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="规格">
        <template #default="{ row }">
          <el-input v-model="row.specification"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="单位" :width="90">
        <template #default="{ row }">
          <el-select
            v-model="row.d_measure_unit_id"
            placeholder=""
            :clearable="false"
          >
            <el-option
              v-for="item in state.dw_data"
              :key="item"
              :label="item.name"
              :value="item.id"
            />
            <template #footer>
              <el-button
                plain
                class="float-right mb-3"
                size="small"
                @click="onLoadDw()"
              >
                刷新
              </el-button>
            </template>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="报账单价" :width="120" align="center">
        <template #default="{ row }">
          <el-input-number
            v-model="row.price"
            :min="0"
            precision="2"
            suffix="元"
            class="!w-full"
            @focus="$onFocus"
            @change="onBuildRowTotal(row)"
          />
        </template>
      </el-table-column>
      <el-table-column label="报账数量" :width="120" align="center">
        <template #default="{ row }">
          <el-input-number
            v-model="row.count"
            :min="0"
            class="!w-full"
            @focus="$onFocus"
            @change="onBuildRowTotal(row)"
          />
        </template>
      </el-table-column>
      <el-table-column label="天数" :width="100" align="center">
        <template #default="{ row }">
          <el-input-number
            v-model="row.day_count"
            :min="0"
            class="!w-full"
            @focus="$onFocus"
            @change="onBuildRowTotal(row)"
          />
        </template>
      </el-table-column>
      <el-table-column label="备注">
        <template #default="{ row }">
          <el-input v-model="row.remark"></el-input>
        </template>
      </el-table-column>
      <el-table-column
        label="报账合计"
        prop="total"
        :formatter="$tab_PriceFormat"
        :width="120"
      />
      <el-table-column label="操作" :width="80" align="center">
        <template #default="{ row, column, index }">
          <el-button
            type="danger"
            link
            size="large"
            @click="onDelete(row, index)"
          >
            <template #icon>
              <el-icon :size="16"><Delete /></el-icon>
            </template>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="submit-box px-2.5">
      <el-button type="warning" size="large" @click="onSubmit">
        提交
      </el-button>
    </div>
    <el-dialog
      v-model="state.showGysk"
      title="选择常用项"
      class="c-el-dialog"
      :before-close="
        () => {
          state.showGysk = false;
        }
      "
      width="95%"
      style="height: 95%"
      :modal="true"
    >
      <c_gysk
        :meeting_id="props.meeting_id"
        :d_cost_type_pid="state.model.d_cost_type_pid"
        :supplier_id="state.model.supplier_id"
        @confirm="onGyskConfirm"
      />
    </el-dialog>
    <el-dialog
      v-model="state.showCbk"
      title="成本库选择"
      class="c-el-dialog"
      :before-close="
        () => {
          state.showCbk = false;
        }
      "
      width="95%"
      style="height: 95%"
      :modal="true"
    >
      <c_cbk
        :meeting_id="props.meeting_id"
        :d_cost_type_pid="state.model.d_cost_type_pid"
        @confirm="onCbkConfirm"
      />
    </el-dialog>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import {
  data_getSupplier,
  dic_getCostType,
  data_getMeetingPlace,
  dic_getMeasureUnit,
} from "@/http/data";
import { meeting_bill_item_add } from "@/http/meeting";
import { toDecimal } from "@/utils/funcs";
import { ElMessage } from "element-plus";

import c_gysk from "./GongYingShangKu.vue";
import c_cbk from "./ChengBenKu.vue";

export default {
  components: {
    c_gysk,
    c_cbk,
  },
  props: {
    meeting_id: Number, //会议Id
    meeting_bill_id: Number, //会议报账单Id
  },
  setup(props, { emit }) {
    const tabDom = ref(null);
    const formDom = ref(null);
    const state = reactive({
      model: {
        meeting_id: props.meeting_id,
      },
      list_data: [],
    });
    onMounted(() => {
      onLoadCblx();
      onLoadGys();
      onLoadFh();
      onLoadDw();
    });

    //获取成本类型
    const onLoadCblx = () => {
      dic_getCostType({ pid: 0 }).then((res) => {
        if (res.status == 200) state.cblx_data = res.data?.data || [];
      });
    };

    //获取供应商
    const onLoadGys = () => {
      data_getSupplier().then((res) => {
        if (res.status == 200) state.gys_data = res.data?.data?.list || [];
      });
    };

    //获取分会
    const onLoadFh = () => {
      data_getMeetingPlace(props.meeting_id).then((res) => {
        if (res.status == 200) state.fh_data = res.data?.data?.list || [];
      });
    };

    //获取物料类型
    const onLoadWllx = () => {
      dic_getCostType({
        pid: state.model.d_cost_type_pid,
      }).then((res) => {
        if (res.status == 200) {
          state.wllx_data = res.data?.data || [];
        }
      });
    };

    //获取单位
    const onLoadDw = () => {
      dic_getMeasureUnit().then((res) => {
        if (res.status == 200) state.dw_data = res.data?.data || [];
      });
    };

    //物料类型选择事件
    const onCostTypeChange = (data, node, row) => {
      row.d_cost_type_pid = data.pid;
    };

    //新增一行
    const onAdd = () => {
      if (!state.model.d_cost_type_pid) {
        ElMessage.warning("请先选择成本类型");
        return false;
      }

      state.list_data.push({
        handle: "add",
        d_cost_type_pid: state.model.d_cost_type_pid,
        type: 0, //类型（0：手动添加，1：成本库添加，2：供应商常用项导入）
      });

      setTimeout(() => {
        tabDom.value.setScrollTop(1000000);
      }, 200);
    };

    //成本库选择完成事件
    const onCbkConfirm = (data) => {
      if (data.meeting_places?.length > 0) {
        data.meeting_places.forEach((place) => {
          data.rows?.forEach((e) => {
            state.list_data.push({
              type: 1, //类型（0：手动添加，1：成本库添加，2：供应商常用项导入）
              meeting_place_id: place.id,
              cost_item_id: e.id,
              d_cost_type_pid: state.model.d_cost_type_pid,
              d_cost_type_id: e.d_cost_type_id,
              name: e.name,
              d_measure_unit_id: e.d_measure_unit_id,
              specification: e.specification,
              price: e.price,
            });
          });
        });
      } else {
        data.rows?.forEach((e) => {
          state.list_data.push({
            type: 1, //类型（0：手动添加，1：成本库添加，2：供应商常用项导入）
            cost_item_id: e.id,
            d_cost_type_pid: state.model.d_cost_type_pid,
            d_cost_type_id: e.d_cost_type_id,
            name: e.name,
            d_measure_unit_id: e.d_measure_unit_id,
            specification: e.specification,
            price: e.price,
          });
        });
      }

      // state.list_data = [...state.list_data, data];
      delete state.showCbk;
    };

    //供应商常用项选择完成事件
    const onGyskConfirm = (data) => {
      if (data.meeting_places?.length > 0) {
        data.meeting_places.forEach((place) => {
          data.rows?.forEach((e) => {
            state.list_data.push({
              handle: "add",
              type: 2, //类型（0：手动添加，1：成本库添加，2：供应商常用项导入）
              meeting_place_id: place.id,
              cost_item_id: e.cost_item_id,
              supplier_cost_item_id: e.id,
              d_cost_type_pid: state.model.d_cost_type_pid,
              d_cost_type_id: e.d_cost_type_id,
              name: e.name,
              d_measure_unit_id: e.d_measure_unit_id,
              specification: e.specification,
              price: e.price,
            });
          });
        });
      } else {
        data.rows?.forEach((e) => {
          state.list_data.push({
            handle: "add",
            type: 2, //类型（0：手动添加，1：成本库添加，2：供应商常用项导入）
            cost_item_id: e.cost_item_id,
            supplier_cost_item_id: e.id,
            d_cost_type_pid: state.model.d_cost_type_pid,
            d_cost_type_id: e.d_cost_type_id,
            name: e.name,
            d_measure_unit_id: e.d_measure_unit_id,
            specification: e.specification,
            price: e.price,
          });
        });
      }
      state.supplier_id_disabled = true; //校验采购明细中是否有从供应商常用项中选择的明细，如果有则禁用供应商选择，防止切换供应商导致采购明细不匹配
      // state.list_data = [...state.list_data, data];
      delete state.showGysk;
    };

    //采购单价、数量、天数改变时，计算行内合计，合计=采购单价*数量*天数
    const onBuildRowTotal = (row) => {
      if (typeof row.price == "number" && typeof row.count == "number") {
        row.total = toDecimal(row.price.toString() || "")
          .times(toDecimal(row.count.toString() || ""))
          .times(toDecimal((row.day_count || "1").toString()));

        onBuildTotal();
      }
    };

    //计算总合计
    const onBuildTotal = () => {
      const total = state.list_data.reduce((pre, cur) => {
        return pre.plus(toDecimal(cur.total?.toString() || ""));
      }, toDecimal("0"));
      state.total = total;
      state.supplier_id_disabled = state.list_data.some((w) => w.type == 2); //校验采购明细中是否有从供应商常用项中选择的明细，如果有则禁用供应商选择，防止切换供应商导致采购明细不匹配
    };

    //清空无效行
    const onDeleteInvalid = () => {
      state.list_data = state.list_data.filter(
        (e) =>
          ((e.type === 1 && e.cost_item_id) ||
            (e.type === 2 && e.supplier_cost_item_id && e.cost_item_id) ||
            e.type === 0) &&
          e.meeting_place_id &&
          e.d_cost_type_id &&
          e.name &&
          e.d_measure_unit_id &&
          typeof e.price == "number" &&
          e.count,
      );
    };

    //删除行
    const onDelete = (row, index) => {
      state.list_data.splice(index, 1);
      onBuildTotal();
    };

    //清空列表
    const onClear = () => {
      state.list_data = [];
      state.supplier_id_disabled = false;
    };

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          if (!state.list_data || state.list_data?.length <= 0) {
            ElMessage.error("请添加采购明细");
            return false;
          }
          state.model.add_item_data = state.list_data;
          meeting_bill_item_add(state.model).then((res) => {
            if (res.status == 200) {
              ElMessage.success("添加成功");
              emit("close");
            }
          });
        }
      });
    };

    //价格输入框失去焦点后格式化内容
    const onPriceBlur = (row, field) => {
      row[field] = row[field] ? priceFormat(row[field]) : "";
      onBuildRowTotal(row);
    };

    // 收集ref
    const setInputRef = (el, rowIndex, field) => {
      const key = `${rowIndex}|${field}`;
      if (el) {
        inputRefs.value[key] = el;
      } else {
        delete inputRefs.value[key];
      }

      // 给 el‑input‑number 原生input绑定监听，屏蔽内部上下键
      if (el?.input) {
        el.input.addEventListener("keydown", (e) => {
          if (["ArrowUp", "ArrowDown"].includes(e.key)) {
            e.preventDefault();
            e.stopPropagation();
          }
        });
      }

      // nextTick(() => {
      //   // el‑input‑number 内部原生输入框
      //   const nativeInput = el.input || el.$el.querySelector("input");
      //   console.log(field, nativeInput);
      //   if (nativeInput) {
      //     nativeInput.addEventListener("keydown", (e) => {
      //       if (["ArrowUp", "ArrowDown"].includes(e.key)) {
      //         e.preventDefault();
      //         e.stopPropagation();
      //       }
      //     });
      //   }
      // });
    };

    // 存储input实例：key格式 "行号|字段名"
    const inputRefs = ref({});

    const handleKeydown = (e, rowIndex, field) => {
      const fieldList = [
        "d_cost_type",
        "meeting_place",
        "name",
        "specification",
        "d_measure_unit",
        "price",
        "count",
        "day_count",
        "remark",
      ]; // 列顺序，控制左右移动

      const colIndex = fieldList.indexOf(field);
      const maxRow = tabDom.value.length - 1;

      let targetRow = rowIndex;
      let targetCol = colIndex;

      switch (e.key) {
        case "ArrowUp":
          e.preventDefault(); // 阻止光标在文本内部跳动
          e.stopPropagation();
          if (rowIndex != 0) targetRow = rowIndex - 1;
          break;
        case "ArrowDown":
          e.preventDefault();
          e.stopPropagation();
          if (rowIndex != maxRow - 1) targetRow = rowIndex + 1;
          break;
        case "ArrowLeft":
          // 如果光标已经在文本最左侧，才跳到上一列
          e.preventDefault();
          e.stopPropagation();
          if (colIndex > 0) targetCol -= 1;
          break;
        case "ArrowRight":
          e.preventDefault();
          e.stopPropagation();
          console.log(colIndex);

          if (colIndex < fieldList.length) targetCol += 1;
          break;
        default:
          return;
      }
      const targetField = fieldList[targetCol];
      const targetKey = `${targetRow}|${targetField}`;
      const targetInput = inputRefs.value[targetKey];

      if (targetInput) {
        // el-input 获取内部原生input
        targetInput.focus();
      }
    };

    return {
      state,
      props,
      formDom,
      tabDom,
      onSubmit,
      onLoadGys,
      onLoadFh,
      onLoadWllx,
      onLoadDw,
      onAdd,
      onCostTypeChange,
      onBuildRowTotal,
      onBuildTotal,
      onDeleteInvalid,
      onDelete,
      onCbkConfirm,
      onGyskConfirm,
      onClear,
      handleKeydown,
      setInputRef,
      onPriceBlur,
    };
  },
};
</script>
<style scoped></style>
